import styled from 'styled-components'

const LogoStyle = styled.div`
	cursor: pointer;
	width: 4.5%;
	z-index: 2;

	.imageCont {
		padding-top: 100%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		width: 4.6%;

		.imageCont {
			padding-top: 100%;
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		width: 5%;

		.imageCont {
			padding-top: 100%;
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		width: 5.1%;

		.imageCont {
			padding-top: 100%;
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		width: 6.6%;

		.imageCont {
			padding-top: 100%;
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		width: 8.6%;

		.imageCont {
			padding-top: 100%;
		}
	}
`

export default LogoStyle
